export default __webpack_public_path__ + "static/media/black.3b1e2ff7.png";